import { computed } from "nanostores";

import { getNotificationProvider, listNotificationProviders } from "../api";
import { createPaginationStore } from "../stores/pagination.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $destinationsPagination = createPaginationStore();

const $paginationParamsString = computed(
  $destinationsPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $destinationsList = createApiStore(listNotificationProviders, {
  mapToOptions: ([paginationParamsString]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    return {
      query: {
        currentPage: paginationParams.currentPage,
        pageSize: paginationParams.pageSize,
      },
    };
  },
  params: [$paginationParamsString],
  storeKey: "destinationsList",
});

export const $destinationContent = createApiStore(getNotificationProvider, {
  mapToOptions: ([destinationId]) => ({
    path: { id: destinationId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "destinationId" in router.params
        ? router.params.destinationId
        : null;
    }),
  ],
  storeKey: "destinationContent",
});
